/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:8d17a3e0-3e05-4776-92b5-cc7128559993",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_LbNS7OrdZ",
    "aws_user_pools_web_client_id": "aio2r8qe0rns7hskpkc5gslus",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "sleeptrack5bd968dc6c5d42779253df1005764ce160105-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
